"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getZapNodesUrl = exports.getNodesUrl = exports.getZapUrl = exports.configureUrlForTemplateMode = void 0;
const url_utils_1 = require("@zapier/url-utils");
exports.configureUrlForTemplateMode = (url, isTemplate) => url_utils_1.addTruthyParamsToUrl(url_utils_1.stripTrailingSlash(`/api/v3/${url}`), {
    is_template: isTemplate,
});
exports.getZapUrl = ({ id = '', isTemplate } = {}) => exports.configureUrlForTemplateMode(`zaps/${id}`, isTemplate);
exports.getNodesUrl = ({ id = '', isTemplate } = {}) => exports.configureUrlForTemplateMode(`nodes/${id}`, isTemplate);
exports.getZapNodesUrl = ({ id, isTemplate }) => exports.configureUrlForTemplateMode(`zaps/${id}/nodes`, isTemplate);
